import { IMultiSuggestResult } from '@cian/geosuggest-widget';
import { pickBy } from 'ramda';

import { mapCities } from './mapCities';
import { mapUndergrounds } from './mapUndergrounds';
import { mapRoads } from './mapRoads';
import { mapDistricts } from './mapDistricts';
import { ISuggestItemDataClassSchema } from '../../repositories/geo-suggest/entities/entities/SuggestItemDataClassSchema';
import { ISuggestRealtorFormResponse } from '../../repositories/geo-suggest/entities/entities/SuggestRealtorFormResponse';

export const prepareSuggestions = ({ suggestions, sortOrder }: ISuggestRealtorFormResponse): IMultiSuggestResult => {
  return {
    sortOrder,
    // NOTE: поле address стало необязательным, однако оно нигде не используется
    suggestions: pickBy(value => value.length, {
      cities: mapCities((suggestions.cities || []) as ISuggestItemDataClassSchema[]),
      undergrounds: mapUndergrounds((suggestions.undergrounds || []) as ISuggestItemDataClassSchema[]),
      roads: mapRoads((suggestions.roads || []) as ISuggestItemDataClassSchema[]),
      districts: mapDistricts((suggestions.districts || []) as ISuggestItemDataClassSchema[]),
    }),
  };
};
